import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AuthService, FeaturesService, PageNotificationService} from '@signature-it/ngx-generic/services';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { GenericConfig } from '@signature-it/ngx-generic/config';

@Component({
    selector: 'newsletter',
    templateUrl: './newsletter.component.html',
    styleUrls: ['./newsletter.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NewsletterComponent implements OnInit {
  news: Array<any>;
  form: UntypedFormGroup;
  submitSpinner = false;
  hideNameInNewsletter = GenericConfig.hideNameInNewsletter || false;
  newsletterRedirect: string = GenericConfig.newsletterRedirect || null;
  constructor(
              protected fb: UntypedFormBuilder,
              protected authService: AuthService,
              private notifySvc: PageNotificationService,
              private FeaturesSvc: FeaturesService
              ) {
  }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
      name: ['', [Validators.required]],
      mail: ['', [Validators.required, Validators.email]],
    });
    if (this.hideNameInNewsletter) {
        this.form.removeControl('name');
    }
  }

  submitForm() {
    if (this.form.dirty && this.form.valid) {
      this.submitSpinner = true;
      this.FeaturesSvc.newsletterRegister(this.form.getRawValue()).subscribe(
          res => {
            this.submitSpinner = false;
            this.notifySvc.set(res, 200).show();
            this.form.reset();
            if(this.newsletterRedirect) {
              this.authService.handleAuthentication(this.newsletterRedirect);
            }
          },
          error => {
            this.submitSpinner = false;
            this.notifySvc.set(error.error).show();
          }
      );
    }
  }

}
